import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";
import { ScrollToTop } from "@/components/ScrollToTop";
import { AnalyticsTracker } from "@/components/AnalyticsTracker";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import Reviews from "@/pages/Reviews";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AnalyticsTracker />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/magazin" element={<Shop />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/recenzii" element={<Reviews />} />
                <Route path="/produs/:id" element={<ProductDetail />} />
                <Route path="/cos" element={<Cart />} />
                <Route path="/finalizare" element={<Checkout />} />
                <Route path="/autentificare" element={<Login />} />
                <Route path="/inregistrare" element={<Register />} />
                <Route path="/cont" element={<ProtectedRoute><Account /></ProtectedRoute>} />
                <Route path="/comanda/:id" element={<OrderConfirmation />} />
                <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
                <Route path="/termeni-si-conditii" element={<LegalPage />} />
                <Route path="/confidentialitate" element={<LegalPage />} />
                <Route path="/politica-cookies" element={<LegalPage />} />
                <Route path="/politica-retur" element={<LegalPage />} />
                <Route path="/politica-livrare" element={<LegalPage />} />
                <Route path="/protectia-consumatorului" element={<LegalPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
